"use strict";

Object.defineProperty(exports, Symbol.toStringTag, {
  value: "Module"
});

var l = function l(e, n) {
  return e == null ? n : n == null ? e : Math.max(e, n);
},
    a = new WeakMap(),
    f = {
  onUpdate: function onUpdate(e, n, o) {
    if (a.set(o, void 0), !o.computedTrend) return;
    var s = n.integer.concat(n.fraction).filter(function (t) {
      return t.type === "integer" || t.type === "fraction";
    }),
        r = e.integer.concat(e.fraction).filter(function (t) {
      return t.type === "integer" || t.type === "fraction";
    }),
        u = s.find(function (t) {
      return !r.find(function (c) {
        return c.pos === t.pos && c.value === t.value;
      });
    }),
        i = r.find(function (t) {
      return !s.find(function (c) {
        return t.pos === c.pos && t.value === c.value;
      });
    });
    a.set(o, l(u == null ? void 0 : u.pos, i == null ? void 0 : i.pos));
  },
  getDelta: function getDelta(e, n, o) {
    var s = e - n,
        r = a.get(o.flow);
    if (!s && r != null && r >= o.pos) return o.length * o.flow.computedTrend;
  }
};

exports.continuous = f;